import httpClient from "@/services";

import type { MyBenefits } from "@/model/my-benefits";
import type { IUserInfo } from "@/hooks/use-user-info";
import type { PlanCoverageInfo } from "@/model/demographics";

export const myBenefits = async (
  userInfo: IUserInfo,
  activeCoverage: PlanCoverageInfo,
): Promise<MyBenefits> => {
  const payloadData = {
    divisionId: userInfo.divisionId,
    groupId: userInfo.groupId,
    loginGroupId: userInfo.loginGroupId,
    memberId: userInfo.memberId,
    planId: activeCoverage.planId,
    claimCoverageCode: activeCoverage.claimCoverageCode,
  };

  const config = {
    method: "POST",
    url: "benefit/benefitDetails",
    headers: {
      Authorization: `Bearer ${userInfo.accessToken}`,
      "Content-Type": "application/json",
      "Accept-Version": "1.0",
    },
    data: payloadData,
  };

  return httpClient.request(config).then((response) => {
    if (response.data.error) {
      throw new Error(response.data.error);
    }
    return response.data.results;
  });
};
